import { get as getCookie, remove as removeCookie, set as setCookie } from 'js/lib/cookie';

export const RECOMMENDATIONS_EXPLAINER_COOKIE = 'recs_explainer';

export const RECOMMENDATIONS_EXPLAINER_CHANGE_EVENT = 'recommendationsExplainer:change';

export function isRecommendationsExplainerEnabled(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return getCookie(RECOMMENDATIONS_EXPLAINER_COOKIE) === '1';
}

export function setRecommendationsExplainerEnabled(enabled: boolean): void {
  if (typeof window === 'undefined') {
    return;
  }

  if (enabled) {
    setCookie(RECOMMENDATIONS_EXPLAINER_COOKIE, '1', { path: '/', days: 30 });
  } else {
    removeCookie(RECOMMENDATIONS_EXPLAINER_COOKIE, { path: '/' });
  }

  window.dispatchEvent(new Event(RECOMMENDATIONS_EXPLAINER_CHANGE_EVENT));
}
